import {readTimelineAnimationWindow} from './animation-window';
const record=(value:unknown):value is Record<string,unknown>=>!!value&&typeof value==='object'&&!Array.isArray(value);
export function hasCodeClocks(document:unknown):boolean{
  return record(document)&&record(document.items)&&Object.values(document.items).some(item=>record(item)&&item.codeClock!==undefined);
}
export function hasValidCodeClock(item:unknown,fps:number):boolean{
  if(!record(item)||item.codeClock===undefined)return true;
  const clock=readTimelineAnimationWindow(item.codeClock);
  if(item.type!=='code'||!clock||clock.startInSeconds>0)return false;
  const start=clock.startInSeconds*fps,end=clock.endInSeconds*fps;
  return Number.isFinite(start)&&Number.isFinite(end)&&Number.isFinite(end-start)&&end-start>=1&&Math.abs(start)<=Number.MAX_SAFE_INTEGER&&Math.abs(end)<=Number.MAX_SAFE_INTEGER&&end-start<=Number.MAX_SAFE_INTEGER;
}
